module.exports = __webpack_public_path__ + "static/media/t3.69fdcf9e.png";